import useReportsDefinition from 'components/Reports/hooks/useReportsDefinition'
import { INavItem } from '.'
import { Flag, Role } from '@api'
import client from '@stores/apollo'
import useIntegrations from 'components/Integrations/hooks/userIntegrations'
import { IIntegration, IIntegrationHash } from '@api/integration/types'
import { legacyMode } from 'App'
let settingsChild = [
  {
    label: 'Company Settings',
    path: 'company_settings/company',
    permitted: [Role.ADMIN, Role.POWER_ADMIN],
  },
  {
    label: 'Application Settings',
    path: 'company_settings/application',
    permitted: [Role.ADMIN, Role.POWER_ADMIN],
  },
  {
    label: 'Desk Book Settings',
    path: 'company_settings/booking',
    permitted: [Role.ADMIN, Role.POWER_ADMIN],
  },
]
const getAllNavIteams = (reportRout: INavItem[], integrationsRouts: INavItem[]) => {
  if (legacyMode) {
    settingsChild = [
      ...settingsChild,
      {
        label: 'Integrations',
        path: 'company_settings/integrations',
        permitted: [Role.ADMIN, Role.IT],
      },
    ]
  }
  return [
    {
      icon: 'house',
      label: 'Dashboard',
      path: 'dashboard',
      permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
    },
    {
      icon: 'briefcase-blank',
      label: 'Portfolio',
      permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
      childNodes: [
        {
          label: 'Global Map',
          path: 'global',
          permitted: [Role.ADMIN, Role.POWER_ADMIN],
        },
        {
          label: 'Portfolio',
          path: 'portfolio',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          path: 'projections',
          label: 'Projections',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          path: 'stack',
          label: 'Stack',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          icon: 'usd-circle',
          path: 'cost',
          label: 'Cost',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
        },
      ],
    },
    {
      icon: 'layer-group',
      label: 'Floors',
      permitted: [
        Role.ADMIN,
        Role.POWER_ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.IT,
        Role.SPACE_CAPTAIN,
        Role.VIEWER,
        Role.BOOKINGS_MANAGER,
      ],
      flags: [Flag.FLOOR_PLAN],
      childNodes: [
        {
          path: 'floor_plan',
          label: 'Floor plan',
          permitted: [
            Role.ADMIN,
            Role.POWER_ADMIN,
            Role.LOCATION_ADMIN,
            Role.DEPARTMENT_ADMIN,
            Role.IT,
            Role.SPACE_CAPTAIN,
            Role.VIEWER,
            Role.BOOKINGS_MANAGER,
          ],
          flags: [Flag.FLOOR_PLAN],
        },
        {
          path: 'move_orders',
          label: 'Employee Moves',
          permitted: [
            Role.ADMIN,
            Role.POWER_ADMIN,
            Role.LOCATION_ADMIN,
            Role.DEPARTMENT_ADMIN,
            Role.SPACE_CAPTAIN,
          ],
        },

        {
          path: 'move_orders',
          label: 'Space Updates',
          permitted: [
            Role.ADMIN,
            Role.POWER_ADMIN,
            Role.LOCATION_ADMIN,
            Role.DEPARTMENT_ADMIN,
            Role.SPACE_CAPTAIN,
          ],
        },
      ],
    },
    {
      icon: 'folder',
      label: 'Manage',
      permitted: [
        Role.ADMIN,
        Role.POWER_ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.SPACE_CAPTAIN,
        Role.BOOKINGS_MANAGER,
      ],
      childNodes: [
        {
          path: 'employees',
          label: 'Employees',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          path: 'leases',
          label: 'Leases',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          path: 'tickets',
          label: 'Tickets',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
        },
        {
          path: 'buildingManager',
          label: 'Buildings & Floors',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN],
        },
        {
          path: 'workplace_groups',
          label: 'Workplace Groups',
          permitted: [Role.ADMIN, Role.POWER_ADMIN],
        },
        {
          path: 'assets',
          label: 'Assets',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN],
        },

        {
          path: 'neighborhoods',
          label: 'Neighborhoods',
          permitted: [
            Role.ADMIN,
            Role.POWER_ADMIN,
            Role.SPACE_CAPTAIN,
            Role.LOCATION_ADMIN,
            Role.DEPARTMENT_ADMIN,
          ],
        },
        {
          path: 'departments',
          label: 'Departments',
          permitted: [Role.ADMIN, Role.POWER_ADMIN],
        },

        {
          path: 'bookings',
          label: 'Bookings',
          permitted: [Role.ADMIN, Role.BOOKINGS_MANAGER, Role.POWER_ADMIN],
        },

        {
          path: 'projections_imports',
          label: 'Projections',
          permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.SPACE_CAPTAIN],
        },

        {
          label: 'Space Types',
          path: 'spaceTypeManagement',
          permitted: [Role.ADMIN, Role.POWER_ADMIN],
        },
        {
          icon: 'city',
          label: 'Building Types',
          path: 'buildingTypeManagement',
          permitted: [Role.ADMIN, Role.POWER_ADMIN],
        },
      ],
    },
    {
      icon: 'file-chart-column',
      path: 'reports',
      label: 'Reports',
      permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
      childNodes: reportRout,
    },

    {
      icon: 'puzzle',
      label: 'Integrations',
      path: 'integrations',
      permitted: [
        Role.ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.IT,
        Role.SPACE_CAPTAIN,
      ],
      childNodes: integrationsRouts,
    },

    {
      icon: 'bomb',
      path: 'sisense',
      label: 'Sisense',
      permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
      flags: [Flag.SISENSE],
    },

    {
      icon: 'gear',
      label: 'Admin Setting',
      permitted: [Role.ADMIN, Role.POWER_ADMIN],
      childNodes: settingsChild,
    },
  ]
}

const useGetNavItems = () => {
  const { definition, loading } = useReportsDefinition({ client: client.gql })
  let reportRouts: INavItem[] = []
  let navItems: INavItem[] = []
  if (!loading && definition.categories.length) {
    reportRouts = definition.categories.map((category) => {
      return {
        path: `reports/${encodeURIComponent(category)}`,
        label: category,
        permitted: [Role.ADMIN, Role.POWER_ADMIN, Role.LOCATION_ADMIN, Role.SPACE_CAPTAIN],
        tag: definition.byCategory[category].length.toString(),
      }
    })
  }
  const integrations = formatAvailable(useIntegrations().available)
  let allCount = 0
  const integrationsRouts = Object.keys(integrations).map((key: string) => {
    allCount += integrations[key].length
    return {
      path: `integrations/${encodeURIComponent(key)}`,
      tag: integrations[key].length.toString(),
      label: key,
      permitted: [
        Role.ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.IT,
        Role.SPACE_CAPTAIN,
      ],
    }
  })
  const ALL_INTEGRATION = 'All'
  const allIntegrations = [
    {
      label: 'Third Party Integrations',
      path: `integrations/${encodeURIComponent(ALL_INTEGRATION)}`,
      permitted: [
        Role.ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.IT,
        Role.SPACE_CAPTAIN,
      ],
      childNodes: [
        {
          path: `integrations/${encodeURIComponent(ALL_INTEGRATION)}`,
          tag: allCount.toString(),
          label: ALL_INTEGRATION,
          permitted: [
            Role.ADMIN,
            Role.LOCATION_ADMIN,
            Role.DEPARTMENT_ADMIN,
            Role.IT,
            Role.SPACE_CAPTAIN,
          ],
        },
        ...integrationsRouts,
      ],
    },
    {
      label: 'API Documentation',
      path: 'integrations/API_Documentation',
      permitted: [
        Role.ADMIN,
        Role.LOCATION_ADMIN,
        Role.DEPARTMENT_ADMIN,
        Role.IT,
        Role.SPACE_CAPTAIN,
      ],
    },
  ]
  if (!loading) navItems = getAllNavIteams(reportRouts, allIntegrations)
  return navItems
}

export default useGetNavItems

const formatAvailable = (available: IIntegration[]) =>
  available.reduce((groups: IIntegrationHash, integration: IIntegration) => {
    if (!groups[integration.category]) {
      groups[integration.category] = []
    }

    groups[integration.category].push(integration)

    return groups
  }, {})
